import { Flex, Spacer, Stack } from '@chakra-ui/react';
import { Cart } from '@diamond/shared/types';
import { Button, Divider } from '@diamond/shared/ui';

import { CartDeleteModal } from './CartDeleteModal';
import { CartSelectAll } from './CartSelectAll';

interface CartControlsProps {
  itemsWithStock: Cart[];
  onSelectAll: () => void;
  onOpenDeleteModal: () => void;
  isDeleteDisabled: boolean;
  isModalOpen: boolean;
  onModalClose: () => void;
  onConfirmDelete: () => void;
}

export const CartControls = ({
  itemsWithStock,
  onSelectAll,
  onOpenDeleteModal,
  isDeleteDisabled,
  isModalOpen,
  onModalClose,
  onConfirmDelete,
}: CartControlsProps) => {
  return (
    <>
      <Flex justify="center">
        <CartSelectAll items={itemsWithStock} />
        <Spacer />
        <Button
          variant="ghost"
          textColor="#0029FF"
          fontSize="16px"
          fontWeight="semibold"
          letterSpacing="0.02em"
          bg="transparent"
          _hover={{ bgColor: 'gray.customGray' }}
          onClick={onOpenDeleteModal}
          isDisabled={isDeleteDisabled}
        >
          Hapus Semua
        </Button>
      </Flex>
      <Stack pt={4}>
        <Divider borderColor="gray.33" w="auto" />
      </Stack>
      <CartDeleteModal
        isOpen={isModalOpen}
        onClose={onModalClose}
        onConfirm={onConfirmDelete}
      />
    </>
  );
};
